<script lang="ts">
  import { api } from '../lib/api';
  import { date, nf } from '../lib/format';
  import { download, loadHistory, removeHistory, saveHistory, toCSV, type HistoryEntry } from '../lib/history';
  let list = $state<HistoryEntry[]>(loadHistory());
  let msg = $state('');

  async function remove(e: HistoryEntry) {
    if (!confirm('Supprimer ce test de l’historique' + (e.shareId ? ' et de nos serveurs' : '') + ' ?')) return;
    if (e.shareId && e.deleteToken) {
      try {
        await api(`/v1/results/${e.shareId}`, { method: 'DELETE', headers: { 'X-Delete-Token': e.deleteToken } });
      } catch (err) {
        msg = 'Suppression distante impossible : ' + (err as Error).message;
      }
    }
    removeHistory(e.at);
    list = loadHistory();
  }
  function clearAll() {
    if (!confirm('Effacer tout l’historique local ? Les résultats déjà publiés restent dans les statistiques anonymisées.')) return;
    saveHistory([]);
    list = [];
  }
  const median = (xs: (number | null)[]) => {
    const v = xs.filter((x): x is number => x !== null).sort((a, b) => a - b);
    return v.length ? v[Math.floor(v.length / 2)]! : null;
  };
</script>

<h1>Historique</h1>
<p class="muted">Vos tests sont enregistrés uniquement dans ce navigateur. Aucun compte n’est nécessaire.</p>
{#if msg}<p class="notice bad">{msg}</p>{/if}
{#if list.length === 0}
  <p>Aucun test pour le moment. <a href="/">Lancer un test</a></p>
{:else}
  <div class="grid summary">
    <div class="card"><span class="muted small">Tests</span><br /><strong>{list.length}</strong></div>
    <div class="card"><span class="muted small">Descendant médian</span><br /><strong>{nf(median(list.map((e) => e.down)))} Mbit/s</strong></div>
    <div class="card"><span class="muted small">Montant médian</span><br /><strong>{nf(median(list.map((e) => e.up)))} Mbit/s</strong></div>
    <div class="card"><span class="muted small">Latence médiane</span><br /><strong>{nf(median(list.map((e) => e.latency)), 1)} ms</strong></div>
  </div>
  <div class="row export">
    <button onclick={() => download('mesurio-historique.csv', toCSV(list), 'text/csv')}>Exporter en CSV</button>
    <button onclick={() => download('mesurio-historique.json', JSON.stringify(list.map(({ deleteToken, ...e }) => (void deleteToken, e)), null, 2), 'application/json')}>Exporter en JSON</button>
    <button class="danger" onclick={clearAll}>Tout effacer</button>
  </div>
  <div class="table-wrap card">
    <table>
      <caption class="sr-only">Historique des tests</caption>
      <thead><tr><th scope="col">Date</th><th scope="col">Serveur</th><th scope="col">Descendant</th><th scope="col">Montant</th><th scope="col">Latence</th><th scope="col">Note</th><th scope="col"><span class="sr-only">Actions</span></th></tr></thead>
      <tbody>
        {#each list as e (e.at)}
          <tr>
            <td>{date(e.at)}</td>
            <td>{e.serverName}</td>
            <td>{nf(e.down)} Mbit/s</td>
            <td>{nf(e.up)} Mbit/s</td>
            <td>{nf(e.latency, 1)} ms</td>
            <td>{e.grade}</td>
            <td class="row">
              {#if e.shareId}<a href="/r/{e.shareId}">Voir</a>{/if}
              <button class="danger" onclick={() => remove(e)} aria-label="Supprimer le test du {date(e.at)}">Supprimer</button>
            </td>
          </tr>
        {/each}
      </tbody>
    </table>
  </div>
{/if}

<style>
  .summary strong { font-size: 1.4rem; }
  .export { margin: 16px 0; }
</style>
